import StoryblokClient from "storyblok-js-client";
import store from "@/store/index.js";

const api = new StoryblokClient({
  accessToken: process.env.VUE_APP_ACCESS_TOKEN,
  cache: {
    clear: "auto",
    type: "memory"
  }
});

if (process.env.VUE_APP_STORYBLOK_BRIDGE === "true") {
  api.get = function get(slug, params) {
    store.commit("LOADING", 1);
    return StoryblokClient.prototype.get
      .call(this, slug, { ...params, version: "draft" })
      .then(res => {
        setTimeout(() => {
          store.commit("LOADING", -1);
        }, 1000);
        return res;
      })
      .catch(e => {
        console.log(e);
        store.commit("LOADING", -1);
        return null;
      });
  };
}

export default api;
